import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  Popover,
  PopoverBody,
  Button,
  Form,
  InputGroup,
  InputGroupText,
  InputGroupAddon
} from "reactstrap";
import { StyledTitle } from "./App";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
  required,
  patente,
  email,
  cuit,
  maxLength7,
  validChasis
} from "./common/validation";
import classNames from "classnames";
import TextField from "./common/TextField";
import SelectField from "./common/SelectField";
import { getFullnameByCuit } from "../requests/afip";
import ModalInfo from "./common/ModalInfo";
import { BrowserView } from "react-device-detect";

const selector = formValueSelector("wizard");

class StepOne extends Component {
  state = {
    popoverOpen: {},
    modal: false
  };

  componentDidMount() {
    if (this.props.product === undefined) {
      this.props.change("product", "cedula-azul");
    }
  }

  closeModal = () => {
    this.setState({ modal: false });
  };

  toggle = name => {
    this.setState({
      popoverOpen: {
        [name]: !this.state.popoverOpen[name]
      }
    });
  };

  handleCuit = async event => {
    try {
      const resp = await getFullnameByCuit(event.target.value);
      this.props.change("step1_fullname", resp.data.p_razon_social);
    } catch (error) {
      console.log(error);
    }
  };

  renderInput = field => <TextField field={field} />;

  renderSelect = field => <SelectField field={field} />;

  render() {
    const { handleSubmit } = this.props;

    return (
      <Fragment>
        <Form onSubmit={handleSubmit}>
          <div className="d-flex flex-wrap">
            <div className="col-md-12 mb-3">
              <FieldStyled
                validate={[required]}
                component={this.renderSelect}
                className="form-control width-input-mobile margin-top-mobile"
                name="product"
                options={
                  <Fragment>
                    <option value="">Trámite a realizar</option>
                    <option value="cedula-azul">
                      Solicitar Nueva Cédula Azul
                    </option>
                    <option value="revocacion-cedula-azul">
                      Dar de baja una Cédula Azul
                    </option>
                    <option value="renovate-cedula-verde">
                      Renovar Cédula Verde por vencimiento
                    </option>
                    <option value="cedula-verde">
                      Solicitar una Cédula Verde adicional
                    </option>
                    <option value="duplicate-cedula-verde">
                      Solicitar duplicado de cédula verde
                    </option>
                  </Fragment>
                }
                popover={
                  <Fragment>
                    <StyledInfo
                      onClick={() => this.toggle("Popover1")}
                      id="Popover1">
                      <i className="fas fa-question-circle" />
                    </StyledInfo>
                    <Popover
                      style={{ fontFamily: "Montserrat" }}
                      placement="right"
                      isOpen={this.state.popoverOpen["Popover1"]}
                      target="Popover1"
                      toggle={() => this.toggle("Popover1")}>
                      <PopoverBody style={{ fontSize: "14px" }}>
                        Cedula de autorización de manejo con su vehiculo para
                        terceros.
                      </PopoverBody>
                    </Popover>
                  </Fragment>
                }
              />
            </div>
            <div className="col-md-6">
              <div className="form-group width-input-mobile">
                <FieldStyled
                  component={this.renderInput}
                  className="form-control"
                  style={{ textTransform: "uppercase" }}
                  type="text"
                  name="patent"
                  validate={[required, patente]}
                  placeholder="Patente Nº*"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group width-input-mobile">
                <FieldStyled
                  component={this.renderInput}
                  className="form-control"
                  style={{ textTransform: "uppercase" }}
                  type="text"
                  name="chasis"
                  validate={[required, validChasis]}
                  placeholder="Ultimos 7 Digitos de Chasis *"
                />
              </div>
            </div>
            <div className="col-md-12">
              <StyledTitle
                align="center"
                className="mt-4 mb-4 py-1 font-size-mobile-title"
                background="#F2F2F2">
                DATOS DEL SOLICITANTE
              </StyledTitle>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <FieldStyled
                  component={this.renderInput}
                  validate={[required, cuit]}
                  className="form-control"
                  type="text"
                  name="step1_cuit"
                  onBlur={this.handleCuit}
                  placeholder="CUIT/CUIL*"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <FieldStyled
                  component={this.renderInput}
                  validate={[required]}
                  className="form-control"
                  type="text"
                  validate={required}
                  name="step1_fullname"
                  placeholder="Nombre y Apellido*"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group select-container">
                <div>
                  <FieldStyled
                    validate={[required]}
                    component={this.renderSelect}
                    className="form-control"
                    name="step1_caracter"
                    options={
                      <Fragment>
                        <option value="">Carácter del Solicitante</option>
                        <option value="titular">Titular del vehículo</option>
                        <option value="apoderado">Apoderado</option>
                        <option value="representante_legal">
                          Representante Legal
                        </option>
                        <option value="curador">Curador</option>
                      </Fragment>
                    }
                    popover={
                      <Fragment>
                        <StyledInfo
                          onClick={() => this.toggle("Popover2")}
                          id="Popover2">
                          <i className="fas fa-question-circle" />
                        </StyledInfo>
                        <Popover
                          style={{ fontFamily: "Montserrat" }}
                          placement="right"
                          isOpen={this.state.popoverOpen["Popover2"]}
                          target="Popover2"
                          toggle={() => this.toggle("Popover2")}>
                          <PopoverBody style={{ fontSize: "14px" }}>
                            Tipo de solicitante: si es el dueño: Titular, o si
                            corresponde a un tercero indicar que tipo de poder
                            tiene sobre el vehiculo.
                          </PopoverBody>
                        </Popover>
                      </Fragment>
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <FieldStyled
                  validate={[required, email]}
                  component={this.renderInput}
                  className="form-control"
                  type="email"
                  name="step1_email"
                  placeholder="Correo Electrónico*"
                />
              </div>
            </div>

            <div className="col-md-12 d-flex justify-content-center my-4">
              <StyledButton type="submit" color="info">
                INICIAR SOLICITUD
              </StyledButton>
            </div>
          </div>
        </Form>
        <BrowserView>
          {this.state.modal && (
            <ModalInfo
              modal={this.state.modal}
              closeModal={this.closeModal}
              textBody={
                <>
                  <p>
                    Estimados clientes, Informamos que debido al Decreto de
                    Necesidad y Urgencia emitido el día 19/03/2020 por la
                    presidencia, como medida de prevención contra el COVID-19 se
                    ha dispuesto la cuarentena obligatoria y cierre de los
                    Registros Seccionales hasta el 31 de Marzo.
                  </p>
                  <p>
                    Se encuentran HABILITADOS todos los turnos posteriores al 1
                    de Marzo de 2020, por lo que pueden modificarse o
                    seleccionar los mismos.
                  </p>
                  <p>
                    Si desea realizar una cambio de turno puede hacerlo en
                    cualquier momento con el Código de Servicio y Numero de
                    Precarga recibidos a su correo en el siguiente link:{" "}
                    <a
                      href={
                        "https://www2.jus.gov.ar/dnrpa-site/#!/modificarTurno"
                      }>
                      https://www2.jus.gov.ar/dnrpa-site/#!/modificarTurno
                    </a>
                  </p>
                  <p>Muchas Gracias</p>
                  <p>Sean responsables cuiden su salud y la de todos.</p>
                </>
              }
              title={"Aviso Importante!"}
              showFooter={true}
            />
          )}
        </BrowserView>
      </Fragment>
    );
  }
}

const StyledButton = styled(Button)`
  background: #30bdbb !important;
  border: none !important;
  border-radius: 0 !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  font-family: Montserrat !important;
  font-weight: 500 !important;
  font-size: 21px !important;
`;

const StyledInfo = styled.span`
  cursor: pointer;
  margin-left: 10px;
  i {
    font-size: 18px;
    color: #30bdbb;
  }
`;

export const FieldStyled = styled(Field)`
  border: 1px solid #30bdbb !important;
  border-radius: 0 !important;
  font-size: 14px !important;
  font-family: "Montserrat" !important;
`;

const mapStateToProps = state => {
  return {
    product: selector(state, "product"),
    patent: selector(state, "patent"),
    chasis: selector(state, "chasis"),
    gclid: selector(state, "gclid")
  };
};

export default reduxForm({
  form: "wizard",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: () => console.log("submited")
})(connect(mapStateToProps)(StepOne));
